import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import i18next from "i18next";
import PopupWrapper from "../Common/PopupWrapper";
import {DocumentTypeEnum} from "./DocumentTypes";
import MessageBox from "@mnjsplatform/components/lib/common/MessageBox";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import PlaceholderWrapper from "../Common/PlaceholderWrapper";
import {actionParams} from "./ActionParams";
import {WorkplaceTypes} from "../Common/constants";

class UploadDocument extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showMessage: false, messageText: "", messageTitle: ""
        }
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async () => {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            let key = {};

            await this.props.dispatch(this.props.dataItem.initialize(key, {
                withParams: true, newItem: true, refresh: false
            }));
        } catch (e) {
            console.error(e);
            this.onCancel();
        }
    }

    onClose = () => {
        if (this.props.onClose) this.props.onClose();
    }

    onSave = () => {
        return confirm(this.props.documentType.CommitMessage)
            .then(() => this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params)))
            .then(() => {
                if (!this.props.dataItem.isError) this.setState({
                    messageText: this.props.dataItem.isError ? this.props.documentType.ErrorMessage : this.props.documentType.SuccessMessage,
                    messageTitle: this.props.dataItem.isError ? i18next.t("Error") : i18next.t("SuccessfulExecution"),
                    showMessage: true
                });
            })
            .catch(() => {
            });
    }

    onCancel = () => {
        if (this.props.onClose) this.props.onClose();
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex" onClick={this.onSave}>{i18next.t("Send")}
                </button>
                <button className="btn btn-regular ml1ex" onClick={this.onCancel}>{i18next.t('Close')}
                </button>
            </div>
        </div>)
    }

    renderParameter = (handler, parameter) => {
        const fn = parameter.Name;
        return (<div key={parameter.Name} className="row">
            <div className="col-md-3 field-title">{handler.lbl(fn)}</div>
            <div className="col-md-9">{handler.ed(fn)}</div>
        </div>)
    }

    renderGroup = (handler, group) => {
        const content = <>
            {group.Group && group.Group.map((group) => this.renderGroup(handler, group))}
            {group.Parameter && group.Parameter.map((parameter) => parameter.ShowInForm && this.renderParameter(handler, parameter))}
        </>
        if (group.Title) return (
            <PlaceholderWrapper id={group.Id} style={group.Style} canCollapse={false} showSplitterLine={true}
                                title={group.Title}>
                {content}
            </PlaceholderWrapper>)
        else return (<div style={group.Style} key={group.Id}>
            {content}
        </div>)
    }

    renderParam = (handler) => {
        const actionParamInfo = actionParams.find(action => action.Id === this.props.documentType.ActionId);
        if(actionParamInfo)
            return (actionParamInfo.Group && actionParamInfo.Group.map((group) => this.renderGroup(handler, group)))
        else{
            return (<div className="row">
                <div className="col-md-12">
                    {handler.fs.map((fi) => {
                        const fn = fi.Name;
                        return (<React.Fragment key={fn}>
                            <div className="row">
                                <div className="col-md-3 field-title text-md-right">
                                    {handler.lbl(fn)}
                                </div>
                                <div className="col-md-9">
                                    {handler.ed(fn)}
                                </div>
                            </div>
                            <hr/>
                        </React.Fragment>)
                    })}
                </div>
            </div>)
        }
    }

    render() {
        if (!this.props.documentType) return null;

        return (<PopupWrapper popupVisible={true} title={this.props.documentType.Title} onClose={this.onClose}
                              showInstruction={false}
                              renderButtons={this.renderButtons} minHeightBody='200px'>
            <MessageBox visible={this.state.showMessage}
                        title={this.state.messageTitle}
                        messageText={this.state.messageText}
                        onClose={this.onClose}/>

            {/*{this.props.documentType.Instruction &&
                <PlaceholderWrapper placeholderId={this.props.documentType.ActionId + "_Instruction"}
                                    canCollapse={false} showSplitterLine={false}>
                    {this.props.documentType.Instruction}
                </PlaceholderWrapper>
                }*/}
            <PlaceholderWrapper placeholderId={this.props.documentType.ActionId} canCollapse={false}
                                showSplitterLine={false}
                                title={`${this.props.documentType.Title} - ${i18next.t("Old_Variant")}`} showHeaderTitle={false}>
                <ComplexParam dataItem={this.props.dataItem_Params}
                              parentDataItem={this.props.dataItem}
                              showApplyButton={false} showSearchBar={false}
                              renderParams={this.renderParam}
                />
            </PlaceholderWrapper>
        </PopupWrapper>)
    }
}

UploadDocument.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    documentType: PropTypes.object,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object
}

UploadDocument.defaultProps = {};

function mapStateToProps(state, ownProps) {

    function getDataItem(isParamSet) {
        switch (ownProps.documentType.DocumentTypeId) {
            case DocumentTypeEnum.Passport:
                switch (state.appState.appParams.workplaceType) {
                    case WorkplaceTypes.Baltika: {
                        return isParamSet ? state.privateDocumentsState.NewDocuments_AddPass_Params : state.privateDocumentsState.NewDocuments_AddPass;
                    }
                    case WorkplaceTypes.Slavutich: {
                        return isParamSet ? state.privateDocumentsState.NewDocuments_AddPassNew_Slav_Params : state.privateDocumentsState.NewDocuments_AddPassNew_Slav;
                    }
                    default: {
                        return isParamSet ? state.privateDocumentsState.NewDocuments_AddPass_Params : state.privateDocumentsState.NewDocuments_AddPass;
                    }
                }
            case DocumentTypeEnum.Pension:
                return isParamSet ? state.privateDocumentsState.PensInsurReq_CreateRegDubPO_Params : state.privateDocumentsState.PensInsurReq_CreateRegDubPO;
            case DocumentTypeEnum.AddressOfficial:
                return isParamSet ? state.privateDocumentsState.NewOfficialAddress_Add_Params : state.privateDocumentsState.NewOfficialAddress_Add;
            case DocumentTypeEnum.HealthInsurance:
                return isParamSet ? state.privateDocumentsState.HiPolicyReq_PO_CreateReq_Params : state.privateDocumentsState.HiPolicyReq_PO_CreateReq;
            case DocumentTypeEnum.AddressFact:
                return isParamSet ? state.privateDocumentsState.ClaimsPD_AddFactAddrForPO_Params : state.privateDocumentsState.ClaimsPD_AddFactAddrForPO;

            default: {
                return null;
            }
        }
    }

    return {
        dataItem: getDataItem(false), dataItem_Params: getDataItem(true), appParams: state.appState.appParams
    }
}

export default connect(mapStateToProps)(UploadDocument)